/** Runtime identity is not the same as native-API availability. In particular,
 * a failed Electron preload must not be reported as a browser/bridge session.
 * User-agent detection is diagnostic only; it never grants native capabilities. */
export function getRuntimeInfo() {
  const api = typeof window === 'undefined' ? undefined : window.electronAPI;
  const userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent;
  return {
    runtime: api || /\bElectron\/\d/i.test(userAgent) ? 'Electron' : 'Browser',
    nativeApiAvailable: !!api,
    nativeFileApiAvailable: typeof api?.readFile === 'function',
  };
}
